// extracted by mini-css-extract-plugin
module.exports = {"call-to-action":"HomePageTitle_call-to-action__xkmny"};